import { AppSettings } from '../app.settings';
import { MergeScreenFiltersDataModel } from './merge-screen-filters-data-model';

export class MergeScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.MERGE_BOOKINGS;
  /** Filters are saved per user + screen + event; the backend rejects a save without it. */
  eventId?: String;
  filterData: MergeScreenFiltersDataModel = new MergeScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    eventId?: String,
    filterData: MergeScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.eventId = options.eventId;
      this.filterData = options.filterData;
    }
  }
};
